'use strict'

import { initLazyLoading, isDesktop, debounce } from 'assets/core/js/common'
import ImagesSlider from 'assets/core/js/module/imagesSlider'
import SliderManager from 'assets/core/js/module/sliderManager'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoomMediasPanel'

import type Swiper from 'swiper'

let resultsSliders: string[] = []

const initResultsSliders = function (): void {
  resultsSliders = []

  const initSlider = (el: HTMLElement): string | undefined => {
    return ImagesSlider(el, {
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_: undefined, current: number, total: number) {
          return current + '/' + total
        },
      },
      spaceBetween: 10,
    })
  }

  if (isDesktop()) {
    document.querySelectorAll<HTMLElement>('.result__image .swiper').forEach(function (el): void {
      if (!el) {
        return
      }

      const slider = initSlider(el)

      if (!slider) {
        return
      }

      resultsSliders.push(slider)
    })
  }

  const resizeFn = debounce(100, () => {
    document.querySelectorAll<HTMLElement>('.result__image .swiper').forEach((el) => {
      const slider = ElementPropertiesManager.getProperty<Swiper>(el, 'slider')

      if (isDesktop() && !slider) {
        initSlider(el)
        window.removeEventListener('resize', resizeFn)
      }
    })
  })

  window.addEventListener('resize', resizeFn)
}

const updateSlidersOnPartialsEvents = function (): void {
  const partialResultsEl = document.querySelector('[data-partial-id="results"]')

  if (partialResultsEl) {
    partialResultsEl.addEventListener(PartialsEvents.PRE_UPDATE, () => {
      resultsSliders.forEach((id) => {
        const slider = SliderManager.getSlider(id)

        if (slider) {
          slider.destroy()
        }
      })
    })

    partialResultsEl.addEventListener(PartialsEvents.POST_UPDATE, () => {
      initResultsSliders()
      initLazyLoading()
    })
  }
}

export default function (): void {
  ImagesSlider(document.getElementById('gallery') as HTMLElement, {
    // eslint-disable-line no-new
    grabCursor: true,
    navigation: {
      prevEl: '#gallery-prev',
      nextEl: '#gallery-next',
    },
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
  })

  initResultsSliders()
  updateSlidersOnPartialsEvents()

  document.querySelectorAll<HTMLImageElement>('.product__images img').forEach((img) => {
    initZoomMediasPanel(img, true)
  })
}
